import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { RouterModule } from '@angular/router';

import { ProfileStoreModule } from '@main-client/src/app/profile/profile-store/profile-store.module';
import { ProfileUnsavedChangesDialogModule } from '@main-client/src/app/profile/profile-unsaved-changes-dialog/profile-unsaved-changes-dialog.module';
import { ProfileViewModule } from '@main-client/src/app/profile/profile-view/profile-view.module';

import { CanDeactivateProfileEditGuardService } from '@main-client/src/app/profile/can-deactivate-profile-edit-guard.service';
import { EnsureProfileSlugGuardService } from '@main-client/src/app/profile/ensure-profile-slug-guard/ensure-profile-slug-guard.service';
import { ProfileSelfQueryParamGuardService } from '@main-client/src/app/profile/profile-self-query-param-guard/profile-self-query-param-guard.service';

import { ProfileViewComponent } from '@main-client/src/app/profile/profile-view/profile-view.component';

import { ActiveUserGuard } from '@main-client/src/app/core/active-user.guard';

@NgModule({
  imports: [
    CommonModule,
    ProfileStoreModule,
    ProfileUnsavedChangesDialogModule,
    ProfileViewModule,
    MatDialogModule,
    RouterModule.forChild([
      {
        canActivate: [EnsureProfileSlugGuardService],
        children: [],
        path: '',
        pathMatch: 'full',
      },
      {
        canActivate: [ActiveUserGuard, ProfileSelfQueryParamGuardService],
        canDeactivate: [CanDeactivateProfileEditGuardService],
        children: [
          {
            loadChildren: () =>
              import('./profile-score-card/profile-score-card.module').then(
                (m) => m.ProfileScoreCardModule,
              ),
            path: 'scorecard',
          },
        ],
        component: ProfileViewComponent,
        path: ':profileSlug',
      },
    ]),
  ],
  providers: [
    CanDeactivateProfileEditGuardService,
    EnsureProfileSlugGuardService,
    ProfileSelfQueryParamGuardService,
  ],
})
export class ProfileModule {}
